import React from 'react';
import { Link } from 'react-router-dom';

const Category = ({category}) => {
  return (
    <>
        {
            category.map((cate,i) => (
                <Link to={`/categories/${cate.code}/${cate.category_name}`} key={i} className="nav-link">{cate.category_name}</Link>
            ))
        }
    </>
  );
};

export default Category;
